import { ISingleBet } from '@bg-shared/business/Reports/interfaces_legacy/Bets';
import { ILotteryItem } from '@bg-shared/interfaces/ILotteryItem';

export const findBetItemIds = (
    bet: ISingleBet,
    gameItems: ILotteryItem[],
): number[] | undefined => {
    const betDataNumbers = bet.betData?.items.map((item) => item.number);

    if (!betDataNumbers?.length) {
        return undefined;
    }

    return betDataNumbers.map(
        (betNumber) => gameItems?.find((gameItem) => gameItem.number === betNumber).id,
    );
};
